import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

/**
 * @method keyMirror
 * @param {Object} obj
 * @returns {void}
 */
function keyMirror(obj) {
  let key;
  const ret = {};
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }

  // eslint-disable-next-line
  for (key in obj) {
    // eslint-disable-next-line
    if (obj.hasOwnProperty(key)) {
      ret[key] = key;
    }
  }
  return ret;
}
var Cx = keyMirror({
  HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED: null,
  HOME_LOANS_LEARNING_MLO_INFO_REQUEST_SUCCESS: null,
  HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT: null,
  HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS: null,
  HOME_LOANS_LEADS_CALL_REQUEST_FAILURE: null,
  HOME_LOANS_LEADS_CALL_VALIDATION_ERRORS: null
});

/**
 * @param {String} action action
 * @param {Object} payload payload
 * @returns {void}
 */
function dispatch(action, payload) {
  // console.groupCollapsed('Dispatching action: ', action);
  // console.log(payload);
  // console.groupEnd();

  // This is a javascript dirty trick. The function passed to
  // setTimeout executes in a new execution context, and exceptions
  // thrown in that context do not bubble out to the calling context
  setTimeout(() => this.Events.pub(action, payload), 0);
}
var Dp = {
  /**
   * @method HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED
   * @param {Object} payload payload
   * @returns {void}
   */
  HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED(payload) {
    // update route
    this.route = payload;
    // dispatch route
    dispatch.bind(this)(Cx.HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED, payload);
  },
  HOME_LOANS_LEARNING_MLO_INFO_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_LEARNING_MLO_INFO_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_GET_A_CALL_BACK_REQUEST_SUBMIT
   * @returns {void}
   */
  HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT() {
    dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT, {});
  },
  /**
   * @method HOME_LOANS_GET_A_CALL_BACK_REQUEST_SUCCESS
   * @param {Object} payload payload
   * @returns {void}
   */
  HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS, {
      ...payload,
      route: this.route
    });
  },
  /**
   * @method HOME_LOANS_GET_A_CALL_BACK_REQUEST_FAILURE
   *   */
  // eslint-disable-next-line consistent-return
  HOME_LOANS_LEADS_CALL_REQUEST_FAILURE(error) {
    if (error.error.responseJSON && error.error.responseJSON.fieldErrors) {
      dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_VALIDATION_ERRORS, error.error.responseJSON.fieldErrors); // eslint-disable-line
      return true;
    }
    dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_REQUEST_FAILURE, {
      ...error,
      route: this.route
    });
  }
};

/**
 * @return {Boolean} is debugging?
 */
function debugging() {
  return spaParams.siteParams.debugging && getParameterByName('debugging') == 'true'; // eslint-disable-line
}

/**
 * @method async
 * @param {String} url url
 * @param {String} methodType method type
 * @param {Object} payload payload
 * @returns {*|Promise|d.promise|promise} async
 */
function async(url, methodType, payload) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      async: true,
      cache: true,
      dataType: 'JSON',
      type: methodType,
      data: JSON.stringify(payload),
      contentType: 'application/json; charset=utf-8',
      /**
       * @method error
       * @param {Object} jqXHR obj
       * @desc If response fails
       * @returns {void}
       */
      error: jqXHR => {
        reject(jqXHR);
      },
      /**
       * @method success
       * @param {Object} payload obj
       * @desc If response is success
       * @returns {void}
       */
      success: payload => {
        // eslint-disable-line
        resolve(payload);
      }
    });
  });
}
var Ep = {
  /**
   * @method getAffiliateInfo
   * @param {String} url - the url for the AJAX call
   * @param {String} urlParams -  affiliate code or nmlsid to be passed in the url
   * @param {String} debugData - debug data
   * @desc Retrieves an affiliate's sub-campaign number and phone number
   * @returns {Function} async call
   */
  getAffiliateInfo(url, urlParams, debugData) {
    if (debugging()) {
      console.log('affiliate info debugging success', debugData);
      return Promise.resolve({
        debugging: true,
        ...debugData
      });
    }
    return async(`${url}${urlParams}`, 'GET').then(response => Promise.resolve(response)).catch(error => Promise.reject({
      error
    })); // eslint-disable-line
  },
  /**
   * @method leadsCall
   * @param {String} url url
   * @param {Object} requestPayload request payload
   * @returns {Function} async callback
   */
  leadsCall(url, requestPayload) {
    return async(url, 'POST', requestPayload).then(response => Promise.resolve({
      responsePayload: response,
      requestPayload
    })).catch(error => Promise.reject({
      error,
      requestPayload
    })); // eslint-disable-line
  },
  /**
   * @method leadsPhoneNumber
   * @param {String} url
   * @param {String} subCampaignCode
   * @async GET request
   * @desc Will update get leads phone number to display on page
   * @returns {Promise} resolve or reject
   */
  // ReST API does not currently respece scsCampCode parameter
  leadsPhoneNumber(url, subCampaignCode, scsCampCode, debugData) {
    console.time && console.time('LEADS_PHONE_NUMBER_REQUEST'); // eslint-disable-line
    if (debugging()) {
      console.log('leads phone number debugging success', debugData);
      return Promise.resolve({
        debugging: true,
        ...debugData
      });
    }

    // make leads phone number request
    return async(`${url}${scsCampCode || subCampaignCode}`, 'GET')

    // if leads phone number is successful
    .then(response => {
      console.timeEnd && console.timeEnd('LEADS_PHONE_NUMBER_REQUEST'); // eslint-disable-line
      return Promise.resolve(response);
    })

    // if leads phone number is failure
    .catch(error => {
      console.timeEnd && console.timeEnd('LEADS_PHONE_NUMBER_REQUEST'); // eslint-disable-line
      return Promise.reject(error);
    });
  }
};

/**
 * @param {String} name name
 * @param {String} url URL
 * @return {String} parameter
 */
function getParameterByName(name, url) {
  if (!url) url = window.location.href; // eslint-disable-line
  name = name.replace(/[\[\]]/g, "\\$&"); // eslint-disable-line

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url); // eslint-disable-line

  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

var Tf = {
  /**
   * @param {Object} route route
   * @return {Promise} object
   */
  getAffiliateInfo(route) {
    // params
    const params = Utility.getQueryParamValues(window.location.href);

    // get persisted campaign code
    const persistedSubCampCode = this.Store.getPersisted('subCampaignCode');
    let subCampCode = persistedSubCampCode && persistedSubCampCode.code;

    // if param exist
    let key = Object.keys(params || {}).find(key => /subcampcode/i.test(key) ? key : false); // eslint-disable-line
    if (key) {
      subCampCode = params[key];
    }
    const scsKey = Object.keys(params || {}).find(key => /scscampcode/i.test(key) ? key : false); // eslint-disable-line
    const scsCampCode = scsKey && params[scsKey];

    // sub campaign code
    if (!subCampCode) {
      subCampCode = spaParams.siteParams.subCampaignCodes[route];
    }
    const loanPurposeMap = {
      mortgage: 'PropertyPurchase',
      refinance: 'Refinance',
      'home-equity': 'EquityRelease'
    };
    const loanPurpose = loanPurposeMap[route];

    // there was some discussion of affiliate code coming from a cookie rather than a query param
    key = Object.keys(params || {}).find(key => /affiliatecode/i.test(key) ? key : false); // eslint-disable-line
    let affiliateCode = key && params[key];
    // fetching nmls from cookie
    key = Object.keys(params || {}).find(key => /nmls/i.test(key) ? key : false); // eslint-disable-line
    let nmls = key && params[key];
    let urlParams = null;
    if (nmls) urlParams = `nmls=${nmls}`;else if (affiliateCode) urlParams = `affiliateCode=${affiliateCode}`;else if (!nmls && !affiliateCode) {
      // try to read the affiliate code from a cookie
      const matches1 = document.cookie.match(/boa_hlts_mlo=([^;]+);/);
      const matches2 = document.cookie.match(/boa_hlts_mlo_affiliate=([^;]+);/);
      if (matches1 && matches1.length > 1) {
        nmls = matches1[1]; // eslint-disable-line
        urlParams = `nmls=${nmls}`;
      } else if (matches2 && matches2.length > 1) {
        affiliateCode = matches2[1]; // eslint-disable-line
        urlParams = `affiliateCode=${affiliateCode}`;
      }
    }
    if (urlParams) {
      return Ep.getAffiliateInfo(spaParams.siteParams.endpoints.getAffiliateInfo.url, urlParams, spaParams.siteParams.endpoints.getAffiliateInfo.debugData).then(response => {
        const phone = response.phoneNumber;
        const matches = phone && phone.match(/(\d{3})(\d{3})(\d{4})/);
        if (matches.length > 3) {
          const digitGroups = matches.slice(1, 4);
          const phoneNumber = digitGroups.join('-');
          this.Store.addData(`${route}_phoneNumber`, {
            phoneNumber
          });
          this.Store.persist('subCampCode', {
            code: response.subCampCode
          });
          const {
            debugging,
            firstName: fName,
            lastName: lName
          } = response;
          const Source = 'MLOWebsite';
          const Subsource = 'Prequal';
          const originationCode = '18098';
          return Promise.resolve({
            debugging,
            route,
            scsCampCode,
            subCampCode,
            phoneNumber,
            affiliateCode: affiliateCode,
            nmls: nmls,
            fName,
            lName,
            loanPurpose,
            Source,
            Subsource,
            originationCode,
            raw: response
          });
        }
        return Promise.reject({
          error: 'no valid phone number provided'
        }); // eslint-disable-line
      }).catch(error => Promise.reject({
        error
      })); // eslint-disable-line
    } else {
      // eslint-disable-line
      const {
        debugData
      } = spaParams.siteParams.endpoints.leadsPhoneNumber;
      const {
        url
      } = spaParams.siteParams.endpoints.leadsPhoneNumber;
      // lets make phone number call
      return Ep.leadsPhoneNumber(url, subCampCode, scsCampCode, debugData).then(payload => {
        // add to store
        this.Store.addData(`${route}_phoneNumber`, payload);

        // persist data
        this.Store.persist('subCampaignCode', {
          code: subCampCode
        });

        // return promise
        return Promise.resolve({
          route,
          scsCampCode,
          subCampCode,
          ...payload
        });
      }).catch(error => Promise.reject({
        error,
        scsCampCode,
        subCampCode
      })); // eslint-disable-line
    }
  },
  /**
   * @method leadsCall
   * @param {Object} payload payload
   * @returns {Promise} resolve reject
   */
  leadsCall(payload) {
    const inputs = {};

    // format email, zip, phone
    inputs.custEmail = payload.emailAddress.trim();
    inputs.mailZipcode = payload.zipCode.slice(0, 5);
    inputs.phoneDay = payload.phoneNumber.replace(/[^\d]/g, '').slice(0, 10);

    // names
    inputs.custFirstName = payload.firstName;
    inputs.custLastName = payload.lastName;

    // format mortgage loan purpose & sub campaign code
    inputs.mtgLoanPurpose = payload.mtgLoanPurpose;
    inputs.subCampaignCode = payload.subCampaignCode;

    // make leads call
    return Ep.leadsCall(spaParams.siteParams.endpoints.leadsCall.url, inputs).then(payload => Promise.resolve(payload)) // eslint-disable-line
    .catch(error => Promise.reject(error));
  }
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/services-home-loans-learning-module",
  "version": "2.0.3",
  "id": "servicesHomeLoansLearningModule",
  "containerID": "homeLoansServicesHomeLoansLearningModule",
  "moduleName": "home-loans-services-home-loans-learning-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "services-home-loans-learning-module",
  "data": {
    "init": "servicesHomeLoansLearningModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "controller",
    "type": "string",
    "values": [],
    "default": "",
    "description": "This parameter allows changing the controller."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @export
 * @class servicesHomeLoansLearningModule
 * @extends {Module}
 */
class servicesHomeLoansLearningModule extends Module {
  /**
   * Creates an instance of Controllers.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof Controllers
   */
  constructor(options, context) {
    // Extend Module
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @method mortgage
   * @route
   * @returns {void}
   */
  mortgage() {
    // update route
    Dp.HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED.bind(this)('mortgage');
    Tf.getAffiliateInfo.bind(this)('mortgage').then(payload => {
      Dp.HOME_LOANS_LEARNING_MLO_INFO_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      console.log('error retrieving affiliate info', error);
    });
  }

  /**
   * @method refinance
   * @route
   * @returns {void}
   */
  refinance() {
    // update route
    Dp.HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED.bind(this)('refinance');
    Tf.getAffiliateInfo.bind(this)('refinance').then(payload => {
      Dp.HOME_LOANS_LEARNING_MLO_INFO_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      console.log('error retrieving affiliate info', error);
    });
  }

  /**
   * @method homeEquity
   * @route
   * @returns {void}
   */
  homeEquity() {
    // update route
    Dp.HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED.bind(this)('home-equity');
    Tf.getAffiliateInfo.bind(this)('home-equity').then(payload => {
      Dp.HOME_LOANS_LEARNING_MLO_INFO_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      console.log('error retrieving affiliate info', error);
    });
  }

  /**
   * @method leadsCall
   * @param {Object} request request
   * @controller
   * @returns {void}
   */
  leadsCall(request) {
    const payload = request.data;

    // Making leads call
    Tf.leadsCall(payload).then(payload => {
      // eslint-disable-line
      Dp.HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_LEADS_CALL_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @returns {void}
   */
  notFound() {
    this.mortgage();
  }

  /**
   * @method updateRoute
   * @returns {void}
   */
  updateRoute() {
    $('.route-all').removeClass('hide');
    $(`.route-${this.route}`).removeClass('hide');
  }

  /**
   * @returns {void}
   */
  showSpinner() {
    $("div[data-sparta-container='mortgage']").find('.small-centered.section-body').not('.route-footer').addClass('hide');
    $('#spinnerModule').fadeIn({
      duration: 200,
      easing: 'linear'
    });
  }

  /**
   * @returns {void}
   */
  checkHashAndTriggerContent() {
    const {
      hash
    } = window.location;

    // Capture #refinance & #/refinance
    if (hash && this.routes[hash.substring(1)]) {
      this.routes[hash.substring(1)]();
    } else if (hash && this.routes[hash.substring(2)]) {
      this.routes[hash.substring(2)]();
    } else {
      this.routes['*notFound']();
    }
  }

  /**
   * @returns {void}
   */
  init() {
    localStorage.clear();

    // configure your routes
    // eslint-disable-next-line no-unused-vars
    this.routes = {
      '': () => {
        this.mortgage.bind(this)();
      },
      mortgage: this.mortgage.bind(this),
      refinance: this.refinance.bind(this),
      'home-equity': this.homeEquity.bind(this),
      '*notFound': this.notFound.bind(this)
    };
    this.checkHashAndTriggerContent();
    window.addEventListener('hashchange', () => {
      this.checkHashAndTriggerContent();
    });

    // when hash route is updated
    this.Events.sub(Cx.HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED, this.showSpinner.bind(this));

    // when hash route is updated
    this.Events.sub(Cx.HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED, this.updateRoute.bind(this));
    this.Events.sub(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT, this.leadsCall.bind(this));
  }
}
registerModuleClass({
  moduleClass: servicesHomeLoansLearningModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { servicesHomeLoansLearningModule as default, moduleConfig };
